import { JSX, ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from '../i18n/i18n';
import { CacheProvider } from './Cache.provider';
import { DatadogProvider } from './Datadog.provider';
import { ConfirmationDialogueProvider } from './ConfirmationDialogue.provider';
import { DataFetchProvider } from './DataFetch.provider';
import { FeatureFlagProvider } from './FeatureFlag.provider';
import { NavMenuProvider } from './NavMenu.provider';
import { PermissionsProvider } from './Permissions.provider';
import { ClientLoginProvider } from './ClientLogin.provider';
import { ClientDataProvider } from './ClientData.provider';
import { AccountCreationProvider } from './AccountCreation.provider';
import { OpenModuleProvider } from './OpenModule.provider';
import { AccountInfoProvider } from './AccountInfo.provider';
import { AccountSummaryProvider } from './AccountSummary.provider';
import { LockedFeaturesProvider } from './LockedFeatures.provider';
import { LockedFeatureDialogue } from './LockedFeatureDialogue.provider';
import { ToastContextProvider } from './Toast.provider';
import { ApprovalWorkflowProvider } from './ApprovalWorkflow.provider';
import { BrandingContextProvider } from './Branding.provider';
import { DialogProvider } from './Dialog.provider';
import { ConfirmDialogProvider } from './ConfirmDialog.provider';
import { UserSettingsProvider } from './UserSettings.provider';
import { AlertDialogProvider } from './AlertDialog.provider';
import { LoggingProvider } from './Logging.provider';
import { SessionProvider } from './Session.provider';
import { LogTimestampProvider } from './LogTimestamp.provider';

export const MainProvider = ({ children }: { children: ReactNode }): JSX.Element => (
  <CacheProvider>
    <SessionProvider>
      <LogTimestampProvider>
        <DatadogProvider>
          <I18nextProvider i18n={i18n}>
            <PermissionsProvider>
              <ClientDataProvider>
                <ApprovalWorkflowProvider>
                  <FeatureFlagProvider>
                    <LockedFeaturesProvider>
                      <LockedFeatureDialogue>
                        <ConfirmationDialogueProvider>
                          <NavMenuProvider>
                            <DataFetchProvider>
                              <AccountSummaryProvider>
                                <AccountInfoProvider>
                                  <ClientLoginProvider>
                                    <BrandingContextProvider>
                                      <AccountCreationProvider>
                                        <ToastContextProvider>
                                          <AlertDialogProvider>
                                            <ConfirmDialogProvider>
                                              <DialogProvider>
                                                <OpenModuleProvider>
                                                  <LoggingProvider>
                                                    <UserSettingsProvider>{children}</UserSettingsProvider>
                                                  </LoggingProvider>
                                                </OpenModuleProvider>
                                              </DialogProvider>
                                            </ConfirmDialogProvider>
                                          </AlertDialogProvider>
                                        </ToastContextProvider>
                                      </AccountCreationProvider>
                                    </BrandingContextProvider>
                                  </ClientLoginProvider>
                                </AccountInfoProvider>
                              </AccountSummaryProvider>
                            </DataFetchProvider>
                          </NavMenuProvider>
                        </ConfirmationDialogueProvider>
                      </LockedFeatureDialogue>
                    </LockedFeaturesProvider>
                  </FeatureFlagProvider>
                </ApprovalWorkflowProvider>
              </ClientDataProvider>
            </PermissionsProvider>
          </I18nextProvider>
        </DatadogProvider>
      </LogTimestampProvider>
    </SessionProvider>
  </CacheProvider>
);
